import { rgb } from 'pdf-lib'

export const clamp = (value, min, max) => Math.min(max, Math.max(min, value))
export const textItemId = item => `${item.pageId || item.documentId || 'document'}:${item.sourceIndex}:${item.textIndex}`
export const normalizeText = text => text.replace(/\r\n?/g, '\n')
export const activeEditorExtraWidth = 20
export const textHighlightBottomExtraPx = 3
export const editResizeEpsilon = 0.005
export const maxAutoZoom = 1.45

const fallbackFontStack = 'Helvetica, Arial, sans-serif'
const genericFontFamilies = new Set(['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui'])

export function hexToRgb(hex) {
  const raw = hex.replace('#', '')
  const value = Number.parseInt(raw, 16)
  return rgb(((value >> 16) & 255) / 255, ((value >> 8) & 255) / 255, (value & 255) / 255)
}

function quoteFontFamily(family) {
  const clean = family?.trim().replace(/^["']|["']$/g, '')
  if (!clean) return ''
  if (genericFontFamilies.has(clean.toLowerCase())) return clean
  return `"${clean.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`
}

export function fontStack(fontFamily) {
  const primary = quoteFontFamily(fontFamily)
  return primary ? `${primary}, ${fallbackFontStack}` : fallbackFontStack
}

interface TextEditorWidth {
  (text: string, fontSize: number, fontFamily: string): number
  canvas?: HTMLCanvasElement
}

export const textEditorWidth: TextEditorWidth = (text, fontSize, fontFamily) => {
  const canvas = textEditorWidth.canvas || document.createElement('canvas')
  textEditorWidth.canvas = canvas
  const ctx = canvas.getContext('2d')
  ctx.font = `${fontSize}px ${fontStack(fontFamily)}`
  return Math.ceil(ctx.measureText(text || ' ').width) + 30
}

export function pdfTextFontFamily(item: any, fontStyle: { fontFamily?: string } = {}) {
  const family = fontStyle.fontFamily || ''
  if (!family || genericFontFamilies.has(family.toLowerCase())) return item.fontName || family
  return family
}

export function wrapText(text, maxWidth, measure) {
  const lines = []
  for (const paragraph of normalizeText(text).split('\n')) {
    const words = paragraph.split(/(\s+)/).filter(Boolean)
    let line = ''
    for (const word of words) {
      const next = line + word
      if (line && measure(next) > maxWidth) {
        lines.push(line.trimEnd())
        line = word.trimStart()
      } else {
        line = next
      }
    }
    lines.push(line.trimEnd())
  }
  return lines.length ? lines : ['']
}
